/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DispatchDeviceApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  saveDispatchData(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'device/saveDispatchBatch',
      Payload
    );
  }
  saveDispatchDataUsingExcel(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'device/saveDispatchDeviceDetailsUsingExcel',
      Payload
    );
  }
  //dispatch device add
  addDispatchDevice(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'device/saveDispatchDeviceDetails',
      Payload
    );
  }
  //fetch dispatch device
  getDispatchDeviceList(
    currentPage,
    pageSize,
    selectedCustomerId,
    search
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'device/getAllDispatchDeviceDetailsList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&selectedCustomerId=' +
        selectedCustomerId +
        '&search=' +
        search +
        '&selectedDeviceModelId='
    );
  }

  getDispatchDeviceBatchList(
    startUin,
    endUin,
    currentPage,
    pageSize,
    search
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'device/getDeviceDetailsByUinRange?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&startUin=' +
        startUin +
        '&endUin=' +
        endUin +
        '&search=' +
        search
    );
  }

  getDispatchBatchList(
    currentPage,
    pageSize,
    selectedCustomerId,
    search
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'device/getAllDispatchBatchDetailsList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&selectedCustomerId=' +
        selectedCustomerId +
        '&search=' +
        search
    );
  }

  getDispatchBatchDeviceList(
    batchId,
    currentPage,
    pageSize,
    search
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'device/getDispatchBatchDeviceDetails?batchId=' +
        batchId +
        '&page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search
    );
  }
  //fetch dispatch by id
  getDispatchDeviceById(id): Observable<any> {
    return this.http.get(
      this.APIService + 'device/getDispatchDeviceDetailsByUid?uid=' + id
    );
  }
  updateDispatchDeviceData(payload): Observable<any> {
    return this.http.put(
      this.APIService + 'device/updateDispatchDeviceDetails',
      payload
    );
  }
  deleteDispatchDeviceData(uid, userId): Observable<any> {
    return this.http.delete(
      this.APIService +
        'device/deleteDispatchDeviceDetailsByUid?uid=' +
        uid +
        '&userId=' +
        userId
    );
  }

  deleteDispatchBatchData(dispatchBatchId): Observable<any> {
    return this.http.delete(
      this.APIService +
        'device/deleteDispatchBatch?dispatchBatchId=' +
        dispatchBatchId
    );
  }

  exportDispatchBatchDeviceDetails(batchId, search): Observable<any> {
    return this.http.get(
      this.APIService +
        'device/exportDispatchBatchDeviceDetails?batchId=' +
        batchId +
        '&search=' +
        search
    );
  }
}
